import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'getUnassignedEmployees'

export default () => (asyncAction(
  name,
  EmployeesService.getUnassignedEmployees,
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/getUnassignedEmployees.js